export default {
  title: 'Actualizar hora de entrega',
  labels: {
    dropoff_time: 'Hora de entrega',
    confirmed: 'Hora confirmada:',
    new_time: 'Nueva hora:',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Hora de entrega actualizada con éxito',
    failed_to_save: 'Error al guardar los cambios',
  },
  alerts: {
    dropoff_time_info: 'La hora actual y la nueva están en la zona horaria {{timezone}} de {{restaurantName}}',
  },
};
